import { render, staticRenderFns } from "./game-3.vue?vue&type=template&id=94db703e&scoped=true&"
import script from "./game-3.vue?vue&type=script&lang=js&"
export * from "./game-3.vue?vue&type=script&lang=js&"
import style0 from "./game-3.vue?vue&type=style&index=0&id=94db703e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94db703e",
  null
  
)

export default component.exports